/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetJobAttachmentsPathParameters } from 'api/actions/helpdesk-get-job-attachments/helpdesk-get-job-attachments-path-parameters';
import { HelpdeskGetJobAttachmentsResponse } from 'api/actions/helpdesk-get-job-attachments/helpdesk-get-job-attachments-response';

type HelpdeskGetJobAttachmentsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetJobAttachments action.
 */
export const helpdeskGetJobAttachmentsActionPath = new SweetPath<keyof HelpdeskGetJobAttachmentsPathParameters>(
  '/help-desk/jobs/{jobId}/attachments',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskGetJobAttachments actions.
 */
export default function createHelpdeskGetJobAttachmentsAction(axios: AxiosInstance) {
  return function helpdeskGetJobAttachmentsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HelpdeskGetJobAttachmentsPathParameters;
    query?: HelpdeskGetJobAttachmentsQueryParameters;
  }) {
    const path = helpdeskGetJobAttachmentsActionPath.insert(parameters);

    return axios.get<HelpdeskGetJobAttachmentsResponse, HelpdeskGetJobAttachmentsResponse>(path, {
      params: query,
      headers,
    });
  };
}
